import init from "./init"

((window, document) => {
    init(window, document)
})(window, document)
